import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";

function resolveDockTarget() {
  if (typeof document === "undefined") return null;
  return document.querySelector(
    ".liveChartWorkspace .workspaceWarningMedium",
  );
}

function LiveTradingCenterDock({ children }) {
  const [target, setTarget] = useState(() => resolveDockTarget());

  useEffect(() => {
    if (typeof document === "undefined") return undefined;

    const updateTarget = () => {
      const nextTarget = resolveDockTarget();
      setTarget((current) => (current === nextTarget ? current : nextTarget));
    };

    updateTarget();
    const observer = new MutationObserver(updateTarget);
    observer.observe(document.body, { childList: true, subtree: true });

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (!target) return undefined;
    target.classList.add("hasTradingCenterDock");
    return () => target.classList.remove("hasTradingCenterDock");
  }, [target]);

  if (!target) return null;

  return createPortal(
    <div className="tradingCenterWarningDock">{children}</div>,
    target,
  );
}

export default LiveTradingCenterDock;
